export default {
  userRegisteredCard: {
    myWorkTitle: "کارت‌های ثبت شده من",
    useBankCardText:
      "دقت کنید برای واریز ریالی فقط از کارت‌های بانکی ثبت شده استفاده نمایید. در غیر اینصورت تراکنش شما به حالت تعلیق در می‌آید."
  }
};
